"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEvents = void 0;
function createEvents() {
    var events = {};
    return {
        emit: function (event) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            for (var _a = 0, _b = events[event] || []; _a < _b.length; _a++) {
                var i = _b[_a];
                i.apply(void 0, args);
            }
        },
        on: function (event, cb) {
            (events[event] = events[event] || []).push(cb);
            return function () { return (events[event] = events[event].filter(function (i) { return i !== cb; })); };
        },
    };
}
exports.createEvents = createEvents;
//# sourceMappingURL=EventEmitter.js.map